// Talks to the PHP backend for the Research Repository (Global) module.
// Backend: assoc-admin/global_research/api/research-api.php
// (see /assoc-admin/global_research/README-INTEGRATION.md)

const RESEARCH_API_BASE =
  "https://assocham.org/assocham_backend/assoc-admin/global_research/api/research-api.php";

/**
 * Fetch research documents from the backend.
 * All params optional: category, year, topic, region, type, q.
 * Called with no params, returns every active document — same shape/behaviour
 * as the old static DOCUMENTS array, so existing client-side filtering,
 * sorting, and pagination in ResearchRepository.jsx keep working unchanged.
 */
export async function fetchResearchDocuments(params = {}) {
  const url = new URL(RESEARCH_API_BASE);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "" && value !== "All") {
      url.searchParams.set(key, value);
    }
  });

  const res = await fetch(url.toString());
  if (!res.ok) {
    throw new Error(`Research API request failed (${res.status})`);
  }
  const data = await res.json();
  if (!data || data.success !== true) {
    throw new Error("Research API returned an unexpected response.");
  }
  return data.documents; // [{ id, title, abstract, category, type, topic, region, author, pages, sizeKB, date, year, downloads, fileUrl, viewUrl, downloadUrl }, ...]
}

/**
 * Compute the Year / Topic / Region / Format filter options for a category,
 * from whatever documents are currently loaded in the browser.
 */
export function optionsFor(documents, category) {
  const pool =
    category === "all" ? documents : documents.filter((d) => d.category === category);

  const years = [...new Set(pool.map((d) => d.year))].sort((a, b) => b - a);
  const topics = [...new Set(pool.map((d) => d.topic).filter(Boolean))].sort();
  const regions = [...new Set(pool.map((d) => d.region).filter(Boolean))].sort();
  const types = [...new Set(pool.map((d) => d.type).filter(Boolean))].sort();

  return { years, topics, regions, types };
}

/** Open a document for viewing — also bumps the backend's view counter. */
export function openDoc(doc) {
  if (!doc?.viewUrl) return;
  window.open(doc.viewUrl, "_blank", "noopener,noreferrer");
}

/** Download a document — also bumps the backend's downloads counter. */
export function downloadDoc(doc) {
  if (!doc?.downloadUrl) return;
  window.location.href = doc.downloadUrl;
}